import type {AnswerModel} from '../../../../../core/domain/Answer/Answer.model';
import type {QuestionModel} from '../../../../../core/domain/Question/Question.model';
import type {Nullable} from '../../../../../utils/utility-types';

import {BaseModel} from '../../../../../core/domain/Base/Base.model';
import {type UserModel} from '../../../../../core/domain/User/User.model';

const ModelName = 'CoachCromModel';

export class CromModel extends BaseModel {
  answers: Nullable<Map<string, AnswerModel>> = null;
  client: UserModel;
  isAiGenerated: boolean = false;
  questions: QuestionModel[];

  constructor(props: CromModel.Props) {
    super(props);
    Object.assign(this, props);
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace CromModel {
  export type Props = {
    answers: Nullable<Map<string, AnswerModel>>;
    client: UserModel;
    id: string;
    isAiGenerated: boolean;
    questions: QuestionModel[];
  };
}
